import React from "react";

type ButtonVariant = "primary" | "secondary" | "danger" | "ghost" | "accent";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: "sm" | "md" | "lg";
}

export function Button({
  variant = "secondary",
  size = "md",
  className = "",
  disabled,
  children,
  ...props
}: ButtonProps) {
  const sizeClass =
    size === "sm"
      ? "px-3 py-1.5 text-xs"
      : size === "lg"
        ? "px-6 py-3 text-sm"
        : "px-4 py-2 text-[13px]";

  const variantClass = {
    primary:
      "bg-[var(--c-primary)] text-[var(--c-primary-text)] hover:bg-[var(--c-primary-hover)] active:opacity-80 border border-[var(--c-primary)]/30 font-semibold",
    accent:
      "bg-[var(--c-accent)] text-[var(--c-accent-text)] hover:bg-[var(--c-accent-hover)] active:opacity-80 border border-[var(--c-accent)]/30 font-semibold",
    secondary:
      "bg-[var(--c-surface-2)] text-[var(--c-text)] border border-[var(--c-border)] hover:border-[var(--c-border-hover)] hover:bg-[var(--c-surface-3)] active:opacity-80",
    danger:
      "bg-[var(--c-danger)]/10 text-[var(--c-danger)] border border-[var(--c-danger)]/20 hover:bg-[var(--c-danger)]/20 active:opacity-80",
    ghost:
      "text-[var(--c-text-secondary)] hover:text-[var(--c-text)] hover:bg-[var(--c-hover)] active:bg-[var(--c-active)]",
  }[variant];

  return (
    <button
      className={`inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 ease-out focus:outline-none focus-visible:ring-1 focus-visible:ring-[var(--c-primary)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--c-ring-offset)] disabled:opacity-40 disabled:cursor-not-allowed ${sizeClass} ${variantClass} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
